export const GET_PAYERS = '@uhc/utility/GET_PAYERS';
export const SET_PAYER = '@uhc/utility/SET_PAYER';
